import FullscreenPopup from '@/lib/fullscreenPopup';
import Base64 from '@/lib/base64';
import i18n from '@/lib/i18n';

class BrowserWindowService {
  constructor(router) {
    this.router = router;
    this.fullscreenPopup = new FullscreenPopup(this);
    this.fullscreenId = 0;
    this.stateCount = 1;

    window.addEventListener('message', event => this.handleMessage(event));
  }

  alert(msg) {
    window.alert(msg);
  }

  backToReferrer() {
    this.router.go(-this.stateCount);
  }

  share(shareData) {
    const linkCopiedMessage = i18n.t('app.link_copied');
    const decodedShareData = {
      ...shareData,
      url: decodeURIComponent(shareData.url)
    };
    if (!navigator.share) {
      this.copyToClipboard(decodedShareData.url).then(() => {
        alert(linkCopiedMessage);
      });
      return;
    }

    navigator.share(decodedShareData).catch(error => {
      // AbortError는 사용자 취소이므로 fallback 하지 않음
      if (error.name !== 'AbortError') {
        this.copyToClipboard(decodedShareData.url).then(() => {
          alert(linkCopiedMessage);
        });
      }
    });
  }

  copyToClipboard(url) {
    if (!navigator.clipboard) return Promise.reject();

    return navigator.clipboard.writeText(url);
  }

  confirm(msg) {
    const response = window.confirm(msg);
    return Promise.resolve(response);
  }

  getScrollTop() {
    return window.scrollY;
  }

  getWindowHeight() {
    return window.innerHeight;
  }

  scrollTo(offset) {
    window.scroll(0, offset);
  }

  addMessageHandler(_messageHandler) {
    // Do nothing
  }

  openFullscreenPopup(url, _targetElement) {
    this.fullscreenId += 1;
    const iframeId = `crema-fullscreen-popup-${this.fullscreenId}`;
    const [baseUrl, params] = url.split('?');
    const paramsWithParentUrl = `${
      params ? `${params}&` : ''
    }parent_url=${encodeURIComponent(window.location.href)}`;
    const finalUrl = baseUrl + '?' + paramsWithParentUrl;
    return this.fullscreenPopup.open(iframeId, finalUrl);
  }

  closeFullscreenPopup(_response = '') {
    const params = new URLSearchParams(window.location.search);
    const closeUrl = params.get('close_url');
    if (closeUrl) {
      this.redirectTo(closeUrl);
      return;
    }

    this.backToReferrer();
  }

  loginUrl(mallLoginUrl, returnUrlParam = null) {
    const closeUrl = new URLSearchParams(window.location.search).get(
      'close_url'
    );
    if (returnUrlParam && closeUrl) {
      const currentUrl = window.location.href;
      const returnUrlWithRedirectBase64 =
        closeUrl + '&crema-redirect-base64=' + Base64.encode(currentUrl);
      return (
        mallLoginUrl +
        '?' +
        returnUrlParam +
        '=' +
        encodeURIComponent(returnUrlWithRedirectBase64)
      );
    }
    return mallLoginUrl;
  }

  redirectTo(url) {
    window.location.href = url;
  }

  setBodyMinHeight(_height) {
    // Do nothing
  }

  clearBodyMinHeight() {
    // Do nothing
  }

  setParentDivMargin(_style) {
    // Do nothing
  }

  setParentDivWidth(_style) {
    // Do nothing
  }

  sendReady(_iframe_id) {
    // Do nothing
  }

  sendHide(_iframe_id) {
    // Do nothing
  }

  pushState(query) {
    this.stateCount += 1;
    this.router.push({ query });
  }

  postMessage(_act, _args) {
    // Do nothing
  }

  handleMessage(event) {
    if (event.data === 'confirm_message') {
      const port2 = event.ports[0];
      if (port2) {
        port2.onmessage = e => {
          if (document.readyState !== 'complete')
            return port2.postMessage(false);

          port2.postMessage(window.confirm(e.data));
        };
      }
    }
  }
}

export default BrowserWindowService;
